// extracted by mini-css-extract-plugin
export default {"title":"TicketRemarks_title__ACSyb","button":"TicketRemarks_button__EUUc8","remark__header":"TicketRemarks_remark__header__0OBnY"};